import apiChange from '../apiChange';

import { ParamsBodyPostCancelChange } from 'utils/typeServices';

// type response = {
//     success: boolean;
//     message: string;
//     errorCode: string;
//     data: {
//         cD_SOLICITACAO: number;
//     }
// }

export const PostCancelChange = async ({ body }: { body: ParamsBodyPostCancelChange }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiChange.post<{ data: any }>('/changeplatform/cancelChange/v1', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
